// import { clsx } from 'clsx';
// import { twMerge } from 'tailwind-merge';

// export function cn(...inputs) {
//   return twMerge(clsx(inputs));
// }

// export function createPageUrl(pageName) {
//   const routes = {
//     'Home': '/',
//     'Marketplace': '/marketplace',
//     'ProductDetail': '/product',
//     'Cart': '/cart',
//     'Checkout': '/checkout',
//     'BuyerOrders': '/orders',
//     'FarmerRegistration': '/farmer/register',
//     'FarmerDashboard': '/farmer/dashboard',
//     'CreateProduct': '/farmer/product/new',
//     'AdminDashboard': '/admin',
//   };

//   if (pageName.includes('?')) {
//     const [page, params] = pageName.split('?');
//     return `${routes[page] || '/'}?${params}`;
//   }

//   return routes[pageName] || '/';
// }

// export function formatCurrency(amount) {
//   return `रू ${amount?.toLocaleString('en-NP') || 0}`;
// }

// export function formatDate(date) {
//   return new Date(date).toLocaleDateString('en-NP', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//   });
// }

// export function generateOrderNumber() {
//   return `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`;
// }

/**
 * ============================================
 * UTILITY FUNCTIONS
 * ============================================
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Create page URL
 */
export function createPageUrl(pageName) {
  const routes = {
    'Home': '/',
    'Marketplace': '/marketplace',
    'ProductDetail': '/product',
    'Cart': '/cart',
    'Checkout': '/checkout',
    'BuyerOrders': '/orders',
    'FarmerRegistration': '/farmer/register',
    'FarmerDashboard': '/farmer/dashboard',
    'CreateProduct': '/farmer/product/new',
    'AdminDashboard': '/admin',
    'PrivacyPolicy': '/privacy',
    'TermsOfService': '/terms',
    'AboutUs': '/about',
    'ContactUs': '/contact',
    'support': '/support',
    'SupportCenter': '/support',
    'ReferralPage': '/referral',
    'DeliveryTracking': '/delivery/track',
    'Wishlist': '/wishlist',
    'BuyerSubscriptions': '/subscriptions',
    'DriverRegistration': '/driver/register',
    'DriverDashboard': '/driver/dashboard',
    'FarmerAnalytics': '/farmer/analytics',
    'FarmerSubscriptionPlans': '/farmer/subscriptions',
    'DriverLogin': '/driver/login',
    'Messages': '/messages',
    'AdminDeliveryManagement': '/admin/delivery-management',
  };

  // Handle query params
  if (pageName.includes('?')) {
    const [page, params] = pageName.split('?');
    return `${routes[page] || '/'}?${params}`;
  }

  return routes[pageName] || '/';
}

/**
 * Format currency (Nepali Rupees)
 */
export function formatCurrency(amount) {
  return `रू ${amount?.toLocaleString('en-NP') || 0}`;
}

/**
 * Format date
 */
export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-NP', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Generate order number
 */
export function generateOrderNumber() {
  return `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`;
}

/**
 * Format phone number with Nepal country code (+977) automatically
 */
export function formatPhone(text) {
  const numbers = text.replace(/[^\d]/g, '');
  if (numbers.length === 10 && !text.includes('+977')) {
    return `+977 ${numbers}`;
  }
  return text;
}

/**
 * Get Page Metadata (Title and Description) for SEO
 */
export function getPageMetadata(pageName, data = {}) {
  const metadata = {
    'Home': {
      title: 'HamroKrishi Bazzar | Nepal\'s Premier Agricultural Marketplace',
      description: 'Connect directly with local farmers in Nepal. Fresh products, fair prices, and quality assurance. Shop at HamroKrishi Bazzar today.'
    },
    'Marketplace': {
      title: 'Explore Agricultural Marketplace | HamroKrishi Bazzar',
      description: 'Browse fresh fruits, vegetables, grains, and organic products from verified farmers across Nepal.'
    },
    'Blog': {
      title: 'Agricultural Insights & Farming Tips | HamroKrishi Blog',
      description: 'Expert advice, farming guides, and success stories from the Nepali agricultural community.'
    },
    'BlogPost': {
      title: `${data.title || 'Blog Post'} | HamroKrishi Bazzar`,
      description: data.excerpt || 'Read our latest agricultural news and tips.'
    },
    'AboutUs': {
      title: 'About HamroKrishi Bazzar | Our Mission & Impact',
      description: 'Learn how HamroKrishi Bazzar is revolutionizing Nepal\'s agricultural landscape by connecting farmers directly to consumers.'
    },
    'ContactUs': {
      title: 'Contact Us | HamroKrishi Bazzar Customer Support',
      description: 'Have questions? Get in touch with our team for support, inquiries, or feedback.'
    },
    'FAQ': {
      title: 'Frequently Asked Questions | HamroKrishi Help Center',
      description: 'Find answers to common questions about buying, selling, and using the HamroKrishi Bazzar platform.'
    },
    'PrivacyPolicy': {
      title: 'Privacy Policy | HamroKrishi Bazzar',
      description: 'Learn how we protect your personal information and maintain your privacy at HamroKrishi Bazzar.'
    },
    'TermsOfService': {
      title: 'Terms of Service | HamroKrishi Bazzar',
      description: 'Read the terms and conditions for using the HamroKrishi Bazzar agricultural marketplace.'
    },
    'CookiePolicy': {
      title: 'Cookie Policy | HamroKrishi Bazzar',
      description: 'Information about how we use cookies to improve your experience on our platform.'
    },
    'Disclaimer': {
      title: 'Disclaimer | HamroKrishi Bazzar',
      description: 'Important legal disclaimers regarding product information and marketplace operations.'
    },
    'SupportCenter': {
      title: 'Support Center | Help & Resources',
      description: 'Access help documents, submit support tickets, and find solutions to technical issues.'
    },
    'ProductDetail': {
      title: `${data.title || 'Product Details'} | HamroKrishi Bazzar`,
      description: data.description ? data.description.substring(0, 160) : 'Buy fresh agricultural products directly from verified farmers in Nepal.'
    }
  };

  return metadata[pageName] || metadata['Home'];
}